<template>
  <div class="-mt-28 py-10 px-4">
    <!-- Opções de atendimento -->
    <div class="flex flex-col md:flex-row justify-center items-center gap-8 mb-10">
      <div class="bg-white rounded-xl shadow-md p-14 w-full max-w-md text-left">
        <div class="mb-4 text-green-500 text-3xl">
          <MessageCircle class="w-16 h-16 text-green-500" stroke-width="1.5" />
        </div>
        <h3 class="text-lg font-bold text-gray-900">Atendimento via WhatsApp</h3>
        <p class="text-gray-700 text-sm">Comercial, Suporte e Financeiro</p>
        <a 
          href="https://wa.me/5511945895095" 
          target="_blank"
          class="text-[#f94368] font-semibold mt-2"
        >
          (11) 94589.5095
        </a>
      </div>

      <div class="bg-white rounded-xl shadow-md p-14 w-full max-w-md text-left">
        <div class="mb-4 text-yellow-500 text-3xl">
          <Ticket class="w-16 h-16 text-yellow-500" stroke-width="1.5" />
        </div>
        <h3 class="text-lg font-bold text-gray-900">Atendimento via Ticket</h3>
        <p class="text-gray-700 text-sm">Acesse o Portal do Cliente</p>
        <a  href="https://painel.integrator.host/login" target="_blank" class="text-[#f94368] font-semibold mt-2 inline-block">Acesse</a>
      </div>
    </div>

    <!-- Formulário de contato -->
    <div class="bg-white rounded-xl shadow-md p-8 max-w-4xl mx-auto mt-24">
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-2">Deixe uma mensagem</h2>
      <p class="text-center text-gray-500 mb-6">Entraremos em contato o mais rápido possível</p>

      <form @submit.prevent="onSubmit" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <input v-model="nome" type="text" placeholder="Nome completo..." class="input" />
          <p v-if="formEnviado && erros.nome" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
            {{ erros.nome }}
          </p>
        </div>

        <div>
          <input v-model="email" type="email" placeholder="Email" class="input" />
          <p v-if="formEnviado && erros.email" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
            {{ erros.email }}
          </p>
        </div>

        <div>
          <input v-model="celular" type="text" placeholder="Celular" class="input" />
          <p v-if="formEnviado && erros.celular" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
            {{ erros.celular }}
          </p>
        </div>

        <div>
          <input v-model="assunto" type="text" placeholder="Assunto" class="input" />
          <p v-if="formEnviado && erros.assunto" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
            {{ erros.assunto }}
          </p>
        </div>

        <textarea v-model="mensagem" placeholder="Mensagem..." class="input md:col-span-2 h-32 resize-none"></textarea>
        <p v-if="formEnviado && erros.mensagem" class="bg-red-500 text-white text-sm rounded px-3 py-1 mt-1 inline-block">
          {{ erros.mensagem }}
        </p>

        <div class="md:col-span-2 flex flex-col items-center text-center">
          <p v-if="erroCaptcha" class="text-red-500 text-xs mt-1">{{ erroCaptcha }}</p>

          <button @click="onSubmit" class="mt-4 bg-[#f94368] hover:bg-pink-600 text-white font-semibold px-6 py-3 rounded-full shadow transition">Enviar</button>

       
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { MessageCircle, Ticket } from 'lucide-vue-next'

const router = useRouter()

// Dados do formulário
const nome = ref('')
const email = ref('')
const celular = ref('')
const assunto = ref('')
const mensagem = ref('')
const erroCaptcha = ref(null)
const formEnviado = ref(false)

// Mensagens de erro
const erros = {
  nome: ref(''),
  email: ref(''),
  celular: ref(''),
  assunto: ref(''),
  mensagem: ref('')
}

// Esperar grecaptcha carregar com segurança
const esperarCarregarGrecaptcha = () =>
  new Promise((resolve) => {
    const checar = () => {
      if (window.grecaptcha && grecaptcha.execute) {
        resolve()
      } else {
        setTimeout(checar, 200)
      }
    }
    checar()
  })

const onSubmit = async () => {
  console.log('[SUBMIT DISPARADO]')
  formEnviado.value = true
  erroCaptcha.value = null
  Object.keys(erros).forEach(key => (erros[key].value = ''))

  let valido = true

  if (!nome.value) { erros.nome.value = 'Nome é obrigatório'; valido = false }
  if (!email.value) { erros.email.value = 'Email é obrigatório'; valido = false }
  if (!celular.value) { erros.celular.value = 'Celular é obrigatório'; valido = false }
  if (!assunto.value) { erros.assunto.value = 'Assunto é obrigatório'; valido = false }
  if (!mensagem.value) { erros.mensagem.value = 'Mensagem é obrigatória'; valido = false }

  if (!valido) return

  try {
    await esperarCarregarGrecaptcha()
    const token = await grecaptcha.execute('6LfN6BkrAAAAAODM9tps1UyKv-BDg5aF3zK0_y3g', { action: 'submit' })


    const payload = {
      nome: nome.value,
      email: email.value,
      celular: celular.value,
      assunto: assunto.value,
      mensagem: mensagem.value,
      recaptchaToken: token
    }

    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/contato/enviar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include'
    })

    const resposta = await response.text()
    console.log('Resposta da API:', resposta)

    if (!response.ok) throw new Error(resposta)

    nome.value = ''
    email.value = ''
    celular.value = ''
    assunto.value = ''
    mensagem.value = ''
    await router.push('/atendimento-obrigado')
  } catch (error) {
    erroCaptcha.value = error.message || 'Erro ao enviar mensagem.'
    console.error('Erro:', error)
  }
}
</script>

<style>
.input {
  @apply w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-400;
}
</style>
